module.exports = __webpack_public_path__ + "static/media/react-js.b7723ebf.png";